import { useEffect } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'

import { FooterComponent } from './components/Footer'
import { NavigationBarComponent } from './components/NavigationBar'
import { ScrollToTop } from './components/ScrollToTop'
import { SpinnerComponent } from './components/Spinner'

import { CreateAffiliatePage } from './pages/CreateAffiliate'
import { CreateCategoryPage } from './pages/CreateCategory'
import { CreateDealsPage } from './pages/CreateDeals'
import { EditAffiliatePage } from './pages/EditAffiliate'
import { EditCategoryPage } from './pages/EditCategory'
import { EditDealPage } from './pages/EditDeal'
import { LoginPage } from './pages/Login'
import { LogoutPage } from './pages/Logout'
import { ManageAffiliatesPage } from './pages/ManageAffiliates'
import { ManageCategoriesPage } from './pages/ManageCategories'
import { ManageDealsPage } from './pages/ManageDeals'

import { useSession } from './hooks/useSession'
import { useSimpleState } from './hooks/useSimpleState'
import { useView } from './hooks/useView'

import { AppProvider } from './hooks/useAppContext/context'

import { theme } from './theme'

import './styles/main.css'

function App() {
    const { Session } = useSession()

    const { _state } = useSimpleState({})

    const {_view} = useView({
        initialView: 'loading',
        views: {
            loading: renderLoading,
            main: renderMain
        }
    })

    useEffect(() => {
      if (Session.fetched && _view.active() === 'loading')
          _view.set('main')
  }, [Session.fetched])

    function renderLoading() {
        return (
            <div className="app-container">
                <SpinnerComponent />
            </div>
        )
    }

    function renderMain() {
        return (
            <div className="app-container">
                <AppProvider value={{ _state }}>
                    <BrowserRouter>
                        <ScrollToTop>
                            {Session.user?.id ? (
                                <>
                                    <NavigationBarComponent />
                                    <Routes>
                                        <Route path="/" element={<ManageDealsPage />} />
                                        <Route path="/create-deals" element={<CreateDealsPage />} />
                                        <Route path="/edit-deal/:id" element={<EditDealPage />} />
                                        <Route path="/affiliates" element={<ManageAffiliatesPage />} />
                                        <Route path="/create-affiliate" element={<CreateAffiliatePage />} />
                                        <Route path="/edit-affiliate/:id" element={<EditAffiliatePage />} />
                                        <Route path="/categories" element={<ManageCategoriesPage />} />
                                        <Route path="/create-category" element={<CreateCategoryPage />} />
                                        <Route path="/edit-category/:id" element={<EditCategoryPage />} />
                                        <Route path="/logout" element={<LogoutPage />} />
                                    </Routes>
                                    <FooterComponent />
                                </>
                            ) : (
                                <Routes>
                                    <Route path="/" element={<LoginPage />} exact />
                                </Routes>
                            )}
                        </ScrollToTop>
                    </BrowserRouter>
                </AppProvider>
            </div>
        )
    }

    return <ThemeProvider theme={theme}>{_view.get()}</ThemeProvider>
}

export default App;
